module.exports = __webpack_public_path__ + "static/audience-view-logo-77d4d860aa04cfd678ccb9d320bfb1d8.png";